import HomePage from "./pages/home";
import ApiPage from "./pages/api";
import GuidePage from "./pages/guide";

export default [{
        name: "home",
        path: "/",
        component: HomePage
    },
    {
        name: "api",
        path: "/api",
        component: ApiPage
    },

    {
        name: "guide",
        path: "/guide/:tag",
        component: GuidePage
    }
];
